//cargar js
export function loadJS(src, callback) {
  var s = document.createElement("script");
  s.src = src;
  s.async = true;
  s.onreadystatechange = s.onload = function () {
    var state = s.readyState;
    if (!callback.done && (!state || /loaded|complete/.test(state))) {
      callback.done = true;
      callback();
    }
  };
  document.getElementsByTagName("head")[0].appendChild(s);
}
export function loadCSS(src) {
  var link = document.createElement("link");
  link.href = src;
  link.type = "text/css";
  link.rel = "stylesheet";
  link.media = "screen";

  document.getElementsByTagName("head")[0].appendChild(link);
}

export function debounce(callback, wait) {
  let timerId;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      callback(...args);
    }, wait);
  };
}

export function mostrarMensaje(mensaje, tiempo) {
  mensaje_obj = document.querySelector(".dialogo_mensaje");
  p_obj = mensaje_obj.querySelector(".dialogo_mensaje__container p");
  p_obj.innerHTML = mensaje;
  mensaje_obj.classList.add("abierto");
  setTimeout(function () {
    document.querySelector(".dialogo_mensaje").classList.remove("abierto");
  }, tiempo);
}

export function copyUrl() {
  if (!window.getSelection) {
    return;
  }
  const dummy = document.createElement("p");
  dummy.textContent = window.location.href;
  document.body.appendChild(dummy);

  const range = document.createRange();
  range.setStartBefore(dummy);
  range.setEndAfter(dummy);

  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);

  document.execCommand("copy");
  document.body.removeChild(dummy);
}

//cookies
export function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
export function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

//detect ios
export function iOS() {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}

//cambiar links

const foodtechModifier = () => {
  if (document.querySelector(".foodtech")) {
    let links = document.querySelectorAll("a");
    links.forEach((link) => {
      if (link.href === "http://localhost:3000/single.html") {
        link.setAttribute("href", "/foodtech-single.html");
      }
    });
  }
};
foodtechModifier();

//Scroll en producto single

let verMasBtn = document.querySelectorAll(".ver_mas__btn");
let tftBeneficios = document.getElementById("tft-beneficios");
let tlwBeneficios = document.getElementById("tlw-beneficios");

verMasBtn.forEach((btn) =>
  btn.addEventListener("click", () => {
    if (tftBeneficios) {
      tftBeneficios.scrollIntoView({
        behavior: "smooth",
      });
    }
    if (tlwBeneficios) {
      tlwBeneficios.scrollIntoView({
        behavior: "smooth",
      });
    }
  })
);
